<template>
  <el-main>
    <div class="banner">
      <el-carousel
        :autoplay="false"
        arrow="never"
        height="482px"
        class="swipe_left little_hand"
      >
        <el-carousel-item
          v-for="(item, index) in needRes.main_image"
          :key="index"
          :label="index + 1"
        >
          <el-image :src="item" fit="cover"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <h3 class="title">{{ needRes.title }}</h3>
    <div class="other_info">
      <div class="time">
        {{ $dayjs(needRes.end_time).format("YYYY-MM-DD") }} 截止
      </div>
      <el-row v-for="item in needRes.param" :key="item.name">
        <el-col :span="4" class="tag">{{ item.name }}：</el-col>
        <el-col :span="16" class="con">{{ item.value }}</el-col>
      </el-row>
    </div>
    <div v-html="needRes.content" class="con"></div>
    <div class="interest" v-if="!isMy">
      <h4>聯繫商家</h4>
      <el-form ref="form" label-width="120px">
        <el-form-item required label="您的需求：">
          <el-input
            type="textarea"
            v-model="content"
            placeholder="请填写您想要了解的相关信息，如产品规格，价格，起订量等等"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form
        ref="form"
        label-width="120px"
        :inline="true"
        class="inline-form"
      >
        <el-form-item label="公司名稱：" required>
          <el-input v-model="company" placeholder="比如XXXXXXX有限公司"></el-input>
        </el-form-item>
        <el-form-item required label="您的姓名：">
          <el-input
            v-model="name"
            placeholder="請輸入您的姓名，比如張先生"
          ></el-input>
        </el-form-item>
        <el-form-item required label="聯繫方式：">
          <el-input
            v-model="phone"
            placeholder="建議填寫您常用手機號"
          ></el-input>
        </el-form-item>
        <el-form-item label="常用郵箱：">
          <el-input v-model="email" placeholder="建議填寫您常用郵箱"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="120px">
        <el-form-item>
          <el-button type="primary" @click="onSubmit">立即提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="interest" v-if="isMy&&quoteList.length>0">
      <h4>报价信息</h4>
      <div class="quote-lists">
        <div class="quote-lists-item" v-for="item in quoteList" :key="item">
          <div class="info">
            <h3>{{item.name}}</h3>
            <p>{{item.company}}</p>
            <p>{{item.phone}}</p>
          </div>
          <p v-html="item.content"></p>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      needRes: {},
      name: "",
      phone: "",
      content: "",
      company:"",
      email:"",
      isMy:false,//是否是我发布的需求
      quoteList:[]
    };
  },
  computed: {
    ...mapState(["user_id","validToken"]),

  },
  watch: {
    $route(val) {
      this.getNewsDetails();
    },
  },
  methods: {
    async getNewsDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/demand/detail/${this.$route.params.id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.needRes = res.data;
      this.needRes.main_image = this.needRes.main_image.split(",");
      this.needRes.param = JSON.parse(this.needRes.param);
      this.isMy=this.needRes.member_id==this.user_id?true:false
      // console.log(this.needRes);
      if(this.isMy){
        this.getQuoteList()
      }
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    async onSubmit() {
      if (!this.validToken) {
          this.$store.state.isDialogVisible = true;
          return false
        }
      if (!this.content) {
        return this.$message.error("請輸入您的需求");
      }
      if (!this.company) {
        return this.$message.error("請輸入公司名稱");
      }
      if (!this.name) {
        return this.$message.error("請輸入您的姓名");
      }
      if (!this.phone) {
        return this.$message.error("請輸入聯繫方式");
      }
      const { data: res } = await this.$http.post(
        `/api/v2/demand/submit`,
         {
            demand_id:this.$route.params.id,
            name: this.name,
            phone: this.phone,
            content: this.content,
            company: this.company,
            email: this.email,
            member_id:this.user_id
          },
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      if (res.code == "200")
        this.$message({
          message: res.msg,
          type: "success",
        });
      this.name = "";
      this.phone = "";
      this.content = "";
      this.email = "";
      this.company = "";
    },
    async getQuoteList() {
      let searchJson = {
        member_id: this.user_id,
      };
      const { data: res } = await this.$http.get(`/api/v2/demand/getOfferByDemand/${this.$route.params.id}`, {
        params: {
          // start: this.start,
          // limit: this.limit,
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.quoteList = eval("(" + res.data + ")").data;
      console.log(this.quoteList);

      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
  },
  created() {
    this.getNewsDetails();
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 900px;
  /deep/.banner {
    width: 100%;
    border-radius: 8px;
    .el-carousel__indicators--labels {
      bottom: 10px !important;
      .el-carousel__indicator {
        padding: 0;
        margin-right: 5px;
      }
      .el-carousel__button {
        opacity: 1;
        padding: 0;
        width: 24px;
        height: 24px;
        font-family: "MicrosoftYaHei";
        font-size: 12px;
        color: #fff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        border-radius: 4px;
        background: #20317f;
      }
      .is-active .el-carousel__button {
        background: #ffffff;
        color: #20317f;
      }
    }
  }
  .title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2c2c2e;
    line-height: 28px;
    text-align: center;
    margin: 12px 0;
  }
  /deep/.other_info {
    position: relative;
    margin-bottom: 40px;
    .time {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2c2c2e;
      line-height: 17px;
      text-align: center;
    }
    .el-row {
      display: flex;
      align-items: center;
    }
    .tag {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #636366;
      line-height: 50px;
    }
    .con {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2c2c2e;
      line-height: 32px;
    }
    .collect {
      position: absolute;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);
      i {
        font-size: 30px;
        margin-right: 18px;
      }
      .el-icon-star-on {
        color: #3135cb;
      }
      .el-button {
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        background: #3135cb;
        padding: 2px 14px;
        border-radius: 28px;
        border: none;
      }
    }
  }
  .con {
    color: #424242;
    font-size: 18px;
    line-height: 48px;
  }
  .con img {
    width: 100% !important;
  }
  .interest {
    h4 {
      font-size: 22px;
      font-weight: 800;
      color: rgba(1, 1, 1, 1);
      line-height: 28px;
      margin-bottom: 40px;
      margin-top: 40px;
    }
    .inline-form {
      
      .el-form-item {
        width: 50%;
        margin-right: 0;
      }
    }
    /deep/.el-form-item__label{
        font-size: 16px;
      }
  }
  .quote-lists-item{
    padding: 10px 20px;
    border-bottom: 1px solid #F2F2F7;
    border-radius: 8px;
    cursor: pointer;
    .info{
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      // justify-content: space-around;
      h3{
        font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #2C2C2E;
line-height: 22px;
      }
      p{
        font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #AEAEB2;
line-height: 20px;
margin: 0 30px;
      }

    }
    p{
      font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #2C2C2E;
line-height: 32px;
    }
  }
  .quote-lists-item:hover{
    background: #F2F2F7;
  }
}
</style>